import React from 'react'
import classes from '../styles.module.scss'
import { useKato } from '../../../../contexts/kato.context'
import { getLang } from '../../../../helpers/utils'
import { useNavigate } from 'react-router-dom'
import { useUser } from '../../../../contexts/user.context'
import KatoItem from '../../components/kato-item.component'
import { oblast } from '../../../../consts/kato.conts'

const baseClass = 'kato-list'

const KatoList = () => {
  const { katoTree, statistics } = useKato();
  const { user } = useUser();

  const sorted = katoTree.sort((a: any, b: any) => a[`name${getLang()}`].localeCompare(b[`name${getLang()}`]))
  if (!katoTree?.length) return null;
  return (
    <div className={classes[baseClass]}>
      {
        user?.kato_access.includes(0) && <KatoItem key={oblast.kato} item={oblast} level={0} statistics={statistics} />
      }
      {sorted.map((item) => (
        <KatoItem key={item.kato} item={item} level={0} statistics={statistics} />
      ))}
    </div>
  )
}

export default KatoList